/**
 * A promise that resolves after `ms` milliseconds.
 *
 * Its own module purely so tests can mock it: swapping this one function for an
 * instantly-resolving stub is what lets flowGenerationService's polling loop be tested without
 * a real (or fake-timer-juggled) multi-second wait.
 */
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default wait;
